import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AppStateFeature } from 'src/app/store/app-state-feature.enum';
import type { MbccState } from 'src/app/store/mbcc/mbcc.state';

const selectDealerLocatorState = createFeatureSelector<MbccState>(AppStateFeature.Mbcc);

export const selectOutlets = createSelector(selectDealerLocatorState, state => state.outlets || []);
